<template>
  <div class="nav">
    <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" menu-trigger='click' :unique-opened='true'>
      <el-menu-item style='height: 55px;' index='/'>
        <!-- <a class="nav-a" @click="onindex">突发环境事件应急预案</a> -->
        <router-link to="/" class="nav-a">突发环境事件应急预案</router-link>
      </el-menu-item>
      <el-menu-item style='height: 55px;' index='/Weatherplan'>
        <!-- <a class="nav-a" @click="onWeatherplan">重污染天气应急预案</a> -->
        <router-link :to="pathUrl" class="nav-a">重污染天气应急预案</router-link>
       </el-menu-item>
      <el-menu-item style='height: 55px;' index='/myunit'>
        <router-link :to="pathUrl2" class="nav-a">申报单位</router-link>
        <!-- <a class="nav-a" @click="onmyunit">申报单位</a> -->
      </el-menu-item>
      <el-menu-item style='height: 55px;' index='/manage/guidefile'>
        <router-link :to="pathUrl3" class="nav-a">法律法规</router-link>
      </el-menu-item>
      <el-menu-item style='height: 55px;' index='/expert/list'>
        <router-link :to="pathUrl4" class="nav-a">专家库</router-link>
      </el-menu-item>
      <el-menu-item style='height: 55px;' index='/user'>
        <!-- <a class="nav-a" @click="onuser">个人资料</a> -->
        <router-link :to="pathUrl5" class="nav-a">个人资料</router-link>
      </el-menu-item>

      <el-menu-item style='height: 55px;' index=''>
          <a style="font-size: 16px;line-height: 55px;" target="_blank" href="https://biaoqi8.yuque.com/docs/share/409b86f8-f7f5-42e6-8622-e6324906b356">
            帮助手册
          </a>
      </el-menu-item>
      <!--<el-submenu v-for="(item,index) in $router.options.routes[7]" :key="item.id" v-if='!item.isShow' :index="item.path">
        <template slot="title">{{item.meta.title}}</template>
        <el-menu-item v-for='(items,i) in item.children' :key="items.id" v-if='isRender(items)' :index="items.path">
          <router-link :to="items.path" :class="{'initPath': items.path=='/'}">{{items.meta.title}}</router-link>
        </el-menu-item>
      </el-submenu> -->
    </el-menu>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      activeIndex: '',
      path: '/',
      isRenderState: 0,
      pathUrl: '/Weatherplan',
      pathUrl2: '/myunit',
      pathUrl3: '/manage/guidefile',
      pathUrl4: '/expert/list',
      pathUrl5: '/user'
    }
  },
  props: {
    routes: {
      type: Array
    }
  },
  computed: {
    ...mapState({
      isRenderingState(state) {
        return state.isRenderingState
      }
    })
  },

  mounted() {
    this.changeDefaultPath()
  },
  watch: {
    $route(to, from) {
      if (to.path == '/login' || to.path == '/home' || to.path == '/refistry') {
        return
      } else {
        sessionStorage.defaultPath = to.path
      }
    },
    isRenderingState() {
      this.isRenderState = this.isRenderingState
    }
  },
  created() {
    if (!sessionStorage.itemName) return
    let currenOrgval = JSON.parse(sessionStorage.itemName)
    if (currenOrgval.type === undefined) {
      this.isRenderState = 0
      return
    } else {
      this.isRenderState = currenOrgval.type
    }
  },
  methods: {
    // 更改初始路径
    changeDefaultPath() {
      let cPath = sessionStorage.defaultPath
      if (cPath) {
        this.path = cPath
      }
    },
    isRender(item) {
      let state = this.isHasRender(item)
      return !item.isShow && state
    },
    isHasRender(arr) {
      let isTrue = false
      if (arr.meta && arr.meta.isRendering) {
        let currItem = arr.meta.isRendering
        for (let i = 0; i < currItem.length; i++) {
          if (this.isRenderState == currItem[i]) {
            isTrue = true
          }
        }
      }
      return isTrue
    },
    // 突发
    onindex() {
      this.$router.push('/')
    },
    // 重污染
    onWeatherplan() {
      this.$router.push('/Weatherplan')
    },
    // 申报单位
    onmyunit() {
      this.$router.push('/myunit')
    },
    // 个人
    onuser() {
      this.$router.push('/user')
    }
  }
}

</script>
<style scoped>
.nav {
  height: 55px;
  box-sizing: border-box;
}

.nav-a {
  font-size: 16px;
  line-height: 55px;
}

</style>



// WEBPACK FOOTER //
// nav.vue?6c57f801